import React, { useState } from "react";
import { fetchCompletarCadastro } from "../../integration/empresas/cadastro/fetchCompletarCadastro";
import { fetchTermosdeuso } from "../../integration/termosdeuso/fetchTermosdeuso";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { uploadFileToS3 } from "./../../functions/AmazonS3";
import "react-toastify/dist/ReactToastify.css";
import { isCNPJ, isCPF, isPhone, isCEP } from "brazilian-values";

const PreCadastroComponente = () => {
  const [termosUsotxt, setTermosUsotxt] = useState([]);

  async function functionTermos() {
    try {
      const resp = await fetchTermosdeuso();

      if (resp) {
        setTermosUsotxt(resp.termo);
      }
    } catch (erro) {}
  }

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(""); // Estado para controlar o passo atual

  const [step, setStep] = useState(1); // Estado para controlar o passo atual
  const [formData, setFormData] = useState({
    businessType: 5,
    cnpj: "",
    razaosocial: "",
    nomefatura: "",
    mediafaturamento: "",
    ticketmedio: "",
    siteempresa: "",
    quaisprodutos: "",
    tipoproduto: "",

    nomeresp: "",
    emailresp: "",
    cpfresp: "",
    telefoneresp: "",
    nascimentoresp: "",
    maeresp: "",

    cep: "",
    endereco: "",
    numero: "",
    bairro: "",
    cidade: "",
    complemento: ""
  });

  const formatCurrency = (value) => {
    value = value.replace(/\D/g, ""); // Remove caracteres não numéricos
    value = (Number(value) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
    return value;
  };

  const handleChangeMaskedmediafaturamento = (e) => {
    const formattedValue = formatCurrency(e.target.value);
    setFormData({ ...formData, mediafaturamento: formattedValue });
  };

  const handleChangeMaskedticketmedio = (e) => {
    const formattedValue = formatCurrency(e.target.value);
    setFormData({ ...formData, ticketmedio: formattedValue });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const formatDate = (value) => {
    // Remove tudo que não for número
    let numericValue = value.replace(/\D/g, "");

    // Aplica a máscara de data (DD/MM/AAAA)
    if (numericValue.length > 2) {
      numericValue = numericValue.replace(/^(\d{2})(\d)/, "$1/$2");
    }
    if (numericValue.length > 5) {
      numericValue = numericValue.replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3");
    }

    return numericValue.slice(0, 10); // Garante que não ultrapasse "DD/MM/AAAA"
  };

  const handleChangeDate = (e) => {
    const formattedValue = formatDate(e.target.value);
    setFormData({ ...formData, nascimentoresp: formattedValue });
  };

  const formatCPF = (value) => {
    // Remove tudo que não for número
    let numericValue = value.replace(/\D/g, "");

    // Aplica a máscara de CPF (000.000.000-00)
    if (numericValue.length > 3) {
      numericValue = numericValue.replace(/^(\d{3})(\d)/, "$1.$2");
    }
    if (numericValue.length > 6) {
      numericValue = numericValue.replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3");
    }
    if (numericValue.length > 9) {
      numericValue = numericValue.replace(
        /^(\d{3})\.(\d{3})\.(\d{3})(\d)/,
        "$1.$2.$3-$4"
      );
    }

    return numericValue.slice(0, 14); // Limita o CPF
  };

  const formatCNPJ = (value) => {
    // Remove tudo que não for número
    let numericValue = value.replace(/\D/g, "");

    // Aplica a máscara de CNPJ (00.000.000/0000-00)
    if (numericValue.length > 2) {
      numericValue = numericValue.replace(/^(\d{2})(\d)/, "$1.$2");
    }
    if (numericValue.length > 5) {
      numericValue = numericValue.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    }
    if (numericValue.length > 8) {
      numericValue = numericValue.replace(
        /^(\d{2})\.(\d{3})\.(\d{3})(\d)/,
        "$1.$2.$3/$4"
      );
    }
    if (numericValue.length > 12) {
      numericValue = numericValue.replace(
        /^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/,
        "$1.$2.$3/$4-$5"
      );
    }

    return numericValue.slice(0, 18); // Limita o CNPJ
  };

  const handleChangeCPF = (e) => {
    const formattedValue = formatCPF(e.target.value);
    setFormData({ ...formData, cpfresp: formattedValue });
  };

  const handleChangeCNPJ = (e) => {
    const formattedValue = formatCNPJ(e.target.value);
    setFormData({ ...formData, cnpj: formattedValue });
  };

  const handleNext = async () => {
    let avancoliberado = true;
    let errorMessage = "";

    //chama api do termo

    if (step === 5) {
      functionTermos();
    }

    // Verifica os campos obrigatórios para cada etapa
    if (step === 1) {
      if (!formData.nomefatura || !formData.cnpj || !formData.razaosocial) {
        avancoliberado = false;
        errorMessage = "Preencha todos os campos obrigatórios.";
      }
      if (!isCNPJ(formData.cnpj)) {
        avancoliberado = false;
        errorMessage = "CNPJ Inválido";
      }
    }

    if (step === 2) {
      if (
        !formData.mediafaturamento ||
        !formData.ticketmedio ||
        !formData.siteempresa ||
        !formData.quaisprodutos ||
        selectedOption === null
      ) {
        avancoliberado = false;
        errorMessage = "Preencha todos os campos obrigatórios.";
      }
    }

    if (step === 3) {
      if (
        !formData.nomeresp ||
        !formData.emailresp ||
        !formData.cpfresp ||
        !formData.telefoneresp ||
        !formData.nascimentoresp ||
        !formData.maeresp
      ) {
        avancoliberado = false;
        errorMessage = "Preencha todos os campos obrigatórios.";
      }
      if (!isCPF(formData.cpfresp)) {
        avancoliberado = false;
        errorMessage = "CPF Inválido";
      }
      if (!isValidEmail(formData.emailresp)) {
        avancoliberado = false;
        errorMessage = "Email Inválido";
      }
      if (!isPhone(formData.telefoneresp)) {
        avancoliberado = false;
        errorMessage = "Telefone Inválido";
      }
    }

    if (step === 4) {
      if (
        !formData.cep ||
        !formData.endereco ||
        !formData.numero ||
        !formData.bairro ||
        !formData.cidade ||
        !formData.complemento
      ) {
        avancoliberado = false;
        errorMessage = "Preencha todos os campos obrigatórios.";
      }
      if (!isCEP(formData.cep)) {
        avancoliberado = false;
        errorMessage = "CEP Inválido";
      }
    }

    // Exibir erro se houver
    if (!avancoliberado) {
      setErrors(errorMessage);
      return;
    }

    // Avançar para o próximo passo se não houver erros
    if (step < 5) {
      setErrors("");
      setStep(step + 1);
    }
  };

  // Função para validar e-mail
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelection = (option) => {
    setSelectedOption(option);
  };

  const [aceito, setAceito] = useState(false);

  const handleConfirmarTermos = () => {
    if (step === 5) {
      setStep(step + 1);
    } else {
      // Aqui você pode processar os dados ou enviar o formulário
      //    console.log("Dados finais: ", formData);
    }
  };

  const [files, setFiles] = useState({
    contratoSocial: null,
    frenteDocumento: null,
    versoDocumento: null,
    selfieDocumento: null
  });

  const [formulariofinal, setFormulariofinal] = useState(false); // Estado para controlar o passo atual

  const handleEnviarform = () => {
    setFormulariofinal(true);
    setStep(17);
    setLoading(true);

    functionEnviarCadastroCompleto();
  };

  async function functionEnviarCadastroCompleto() {
    try {
      const resp = await fetchCompletarCadastro({ formData, selectedOption });

      if (resp) {
        setLoading(false);

        // Limpa o localStorage
        localStorage.clear();

        // Atualiza a tela
        window.location.reload();
      }
    } catch (erro) {}
  }

  const [isLoading, setIsLoading] = useState(false); // Estado para controle do carregamento
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const requiredFields = [
    "contratoSocial",
    "frenteDocumento",
    "versoDocumento",
    "selfieDocumento"
  ];

  const allUploaded = requiredFields.every((key) => uploadSuccess[key]);

  const handleFileChange = async (event, key) => {
    const file = event.target.files[0];
    if (file && formData.cnpj) {
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      if (!allowedTypes.includes(file.type)) {
        console.error("❌ Tipo de arquivo não permitido.");
        return;
      }

      // Atualiza o estado de loading para o campo específico
      setIsLoading((prev) => ({ ...prev, [key]: true }));
      setUploadSuccess((prev) => ({ ...prev, [key]: false })); // Marca como não enviado inicialmente
      setUploadProgress((prev) => ({ ...prev, [key]: 0 })); // Reset progress on new upload

      try {
        const fileUrl = await uploadFileToS3(
          file,
          key,
          formData.cnpj,
          (progress) => {
            // Atualiza a barra de progresso para o campo específico
            setUploadProgress((prev) => ({ ...prev, [key]: progress }));
          }
        );

        setFiles((prevFiles) => ({
          ...prevFiles,
          [key]: file
        }));

        // Marca como enviado com sucesso
        setUploadSuccess((prev) => ({ ...prev, [key]: true }));
      } catch (error) {
        console.error("❌ Erro ao enviar arquivo:", error);
      } finally {
        // Finaliza o estado de carregamento
        setIsLoading((prev) => ({ ...prev, [key]: false }));
      }
    } else {
      console.error("❌ Arquivo ou CNPJ não encontrado.");
    }
  };

  return (
    <div className="flex flex-col h-screen">
      {/* Colunas do meio */}
      <div className="flex flex-grow">
        {/* Coluna do menu */}

        <div className="w-full md:flex-1 bg-gradient-to-r from-[#f2f2f2] to-[#f2f2f2]">
          <div className="flex items-center justify-center bg-cover bg-center mb-10">
            <div className="flex justify-center items-center self-center w-full max-w-xl p-6 rounded-2xl">
              <div className="w-full">
                {step <= 2 && (
                  <>
                    <h1 className="text-2xl text-center font-semibold text-gray-700 mb-6">
                      Vamos começar
                    </h1>
                    <p className="mb-6 text-center">
                      Agora vamos preencher os dados da sua empresa para usar a
                      Medusa Payments. Você não poderá alterar esses dados
                      futuramente.
                    </p>
                  </>
                )}

                {step < 4 && step > 2 && (
                  <>
                    <h1 className="text-2xl text-center font-semibold text-gray-700 mb-6">
                      Dados do responsável
                    </h1>
                    <p className="mb-6 text-center">
                      Agora precisaremos dos dados do representante legal da
                      empresa. Caso seja pessoa física, preencha com seus dados
                      pessoais.
                    </p>
                  </>
                )}

                {step >= 4 && step < 5 && (
                  <>
                    <h1 className="text-2xl text-center font-semibold text-gray-700 mb-6">
                      Endereço
                    </h1>
                    <p className="mb-6 text-center">
                      Quase lá! Precisamos das informações do endereço da sua
                      empresa.
                    </p>
                  </>
                )}

                {step === 6 && (
                  <>
                    <h1 className="text-2xl text-center font-semibold text-gray-700 mb-6">
                      Envio de documentos pendentes
                    </h1>
                    <p className="mb-6 text-center">
                      realize o upload dos seus documentos para começar utilizar
                      a plataforma. Documentos incompletos podem fazer com que a
                      sua solicitação seja recusada.
                    </p>
                  </>
                )}

                {formulariofinal && (
                  <>
                    {loading ? (
                      <div className="flex justify-center items-center flex-col">
                        <AiOutlineLoading3Quarters className="w-16 h-16 text-[#baa78e]   animate-spin mb-4" />
                        <p className="text-center text-gray-600">
                          Enviando documentos...
                        </p>
                      </div>
                    ) : (
                      <>
                        <h1 className="text-2xl text-center font-semibold text-green-400 mb-6">
                          Documentos enviados!
                        </h1>
                        <p className="mb-6 text-center">
                          Agradecemos por enviar os documentos. Nossa equipe irá
                          analisá-los e em breve entraremos em contato com uma
                          resposta.
                        </p>
                      </>
                    )}
                  </>
                )}

                {/* Exibição de campos dependendo do step */}
                {step === 1 && (
                  <>
                    {errors && (
                      <div className="flex mb-5 bg-red-500 rounded-lg p-2 justify-center items-center flex-col">
                        <p className="text-center text-white">{errors}</p>
                      </div>
                    )}

                    <div className="mb-4">
                      <label
                        htmlFor="businessType"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Tipo de Empresa
                      </label>
                      <select
                        id="businessType"
                        name="businessType"
                        value={formData.businessType}
                        onChange={handleChange}
                        className="mt-1 block w-full text-slate-700 px-3 py-2 border border-gray-300 rounded-md"
                      >
                        <option value="pessoa_juridica  ">
                          Pessoa Jurídica
                        </option>
                      </select>
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="cnpj"
                        className="block text-sm font-medium text-gray-700"
                      >
                        CNPJ
                      </label>
                      <input
                        type="text"
                        id="cnpj"
                        name="cnpj"
                        value={formData.cnpj}
                        onChange={handleChangeCNPJ}
                        className="mt-1 block w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-blue-500"
                        maxLength="18" // CNPJ tem no máximo 18 caracteres
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="razaosocial"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Razão Social
                      </label>
                      <input
                        type="text"
                        id="razaosocial"
                        name="razaosocial"
                        value={formData.razaosocial}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="nomefatura"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Nome na Fatura
                      </label>
                      <input
                        type="text"
                        id="nomefatura"
                        name="nomefatura"
                        value={formData.nomefatura}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>
                  </>
                )}

                {step === 2 && (
                  <>
                    {errors && (
                      <div className="flex mb-5 bg-red-500 rounded-lg p-2 justify-center items-center flex-col">
                        <p className="text-center text-white">{errors}</p>
                      </div>
                    )}
                    <div className="mb-4">
                      <label
                        htmlFor="mediafaturamento"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Média de Faturamento
                      </label>
                      <input
                        type="text"
                        id="mediafaturamento"
                        name="mediafaturamento"
                        value={formData.mediafaturamento}
                        onChange={handleChangeMaskedmediafaturamento}
                        placeholder="R$ 0,00"
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="ticketmedio"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Ticket Médio
                      </label>
                      <input
                        type="text"
                        id="ticketmedio"
                        name="ticketmedio"
                        value={formData.ticketmedio}
                        onChange={handleChangeMaskedticketmedio}
                        placeholder="R$ 0,00"
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="siteempresa"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Site da Empresa
                      </label>
                      <input
                        type="text"
                        id="siteempresa"
                        name="siteempresa"
                        value={formData.siteempresa}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="quaisprodutos"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Quais produtos você vende?
                      </label>
                      <input
                        type="text"
                        id="quaisprodutos"
                        name="quaisprodutos"
                        value={formData.quaisprodutos}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Qual tipo de produto você vende?
                      </label>
                      <div className="flex space-x-4">
                        <button
                          onClick={() => handleSelection("fisico")}
                          className={`w-full py-2 rounded-md text-slate-400 font-semibold transition-all duration-300 ${
                            selectedOption === "fisico"
                              ? "bg-[#baa78e] text-white"
                              : "bg-gray-200"
                          }`}
                        >
                          Produto Físico
                        </button>
                        <button
                          onClick={() => handleSelection("digital")}
                          className={`w-full py-2 rounded-md text-slate-400 font-semibold transition-all duration-300 ${
                            selectedOption === "digital"
                              ? "bg-[#baa78e] text-white"
                              : "bg-gray-200"
                          }`}
                        >
                          Produto Digital
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {step === 3 && (
                  <>
                    {errors && (
                      <div className="flex mb-5 bg-red-500 rounded-lg p-2 justify-center items-center flex-col">
                        <p className="text-center text-white">{errors}</p>
                      </div>
                    )}
                    <div className="mb-4">
                      <label
                        htmlFor="nomeresp"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Nome Completo
                      </label>
                      <input
                        type="text"
                        id="nomeresp"
                        name="nomeresp"
                        value={formData.nomeresp}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="emailresp"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Email
                      </label>
                      <input
                        type="text"
                        id="emailresp"
                        name="emailresp"
                        value={formData.emailresp}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="cpfresp"
                        className="block text-sm font-medium text-gray-700"
                      >
                        CPF
                      </label>
                      <input
                        type="text"
                        id="cpfresp"
                        name="cpfresp"
                        value={formData.cpfresp}
                        onChange={handleChangeCPF}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                        maxLength="14" // CPF tem no máximo 14 caracteres
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="telefoneresp"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Telefone Para contato
                      </label>
                      <input
                        type="text"
                        id="telefoneresp"
                        name="telefoneresp"
                        value={formData.telefoneresp}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="nascimentoresp"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Data de Nascimento
                      </label>
                      <input
                        type="text"
                        id="nascimentoresp"
                        name="nascimentoresp"
                        value={formData.nascimentoresp}
                        onChange={handleChangeDate}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                        maxLength="10" // Impede mais de 10 caracteres
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="maeresp"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Nome da Mãe
                      </label>
                      <input
                        type="text"
                        id="maeresp"
                        name="maeresp"
                        value={formData.maeresp}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>
                  </>
                )}

                {step === 4 && (
                  <>
                    {errors && (
                      <div className="flex mb-5 bg-red-500 rounded-lg p-2 justify-center items-center flex-col">
                        <p className="text-center text-white">{errors}</p>
                      </div>
                    )}
                    <div className="mb-4">
                      <label
                        htmlFor="cep"
                        className="block text-sm font-medium text-gray-700"
                      >
                        CEP
                      </label>
                      <input
                        type="text"
                        id="cep"
                        name="cep"
                        value={formData.cep}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4 flex gap-4">
                      <div className="flex-1">
                        <label
                          htmlFor="endereco"
                          className="text-sm font-medium text-gray-700"
                        >
                          Endereço
                        </label>
                        <input
                          type="text"
                          id="endereco"
                          name="endereco"
                          value={formData.endereco}
                          onChange={handleChange}
                          className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                        />
                      </div>

                      <div className="w-1/4">
                        <label
                          htmlFor="numero"
                          className="text-sm font-medium text-gray-700"
                        >
                          Número
                        </label>
                        <input
                          type="text"
                          id="numero"
                          name="numero"
                          value={formData.numero}
                          onChange={handleChange}
                          className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                        />
                      </div>
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="bairro"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Bairro
                      </label>
                      <input
                        type="text"
                        id="bairro"
                        name="bairro"
                        value={formData.bairro}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="cidade"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Cidade
                      </label>
                      <input
                        type="text"
                        id="cidade"
                        name="cidade"
                        value={formData.cidade}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="complemento"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Complemento
                      </label>
                      <input
                        type="text"
                        id="complemento"
                        name="complemento"
                        value={formData.complemento}
                        onChange={handleChange}
                        className="mt-1   w-full px-3 text-gray-700 py-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:border-gray-300"
                      />
                    </div>
                  </>
                )}

                {step === 5 && (
                  <>
                    <div className="p-4 border rounded-md shadow-md max-w-lg mx-auto bg-white">
                      <h1 className="text-2xl text-center font-semibold text-gray-700 mb-6">
                        Termos e Condições
                      </h1>

                      {!termosUsotxt && (
                        <div className="flex justify-center items-center flex-col">
                          <AiOutlineLoading3Quarters className="w-16 h-16 text-[#baa78e]   animate-spin mb-4" />
                          <p className="text-center text-gray-600">
                            Carregando Termos de Uso, aguarde...
                          </p>
                        </div>
                      )}

                      {termosUsotxt && (
                        <div className="border p-3 rounded-md max-h-60 overflow-y-auto text-sm text-gray-700">
                          <p> {termosUsotxt} </p>
                        </div>
                      )}

                      <div className="flex items-center gap-2 mt-3">
                        <input
                          type="checkbox"
                          id="aceito"
                          checked={aceito}
                          onChange={() => setAceito(!aceito)}
                          className="w-4 h-4  "
                        />
                        <label
                          htmlFor="aceito"
                          className="text-sm text-gray-700"
                        >
                          Li e aceito todos os termos e condições
                        </label>
                      </div>
                    </div>
                  </>
                )}

                {step === 6 && (
                  <div className="p-3 border rounded-md shadow-md bg-white">
                    {[
                      "contratoSocial",
                      "frenteDocumento",
                      "versoDocumento",
                      "selfieDocumento"
                    ].map((key) => (
                      <div key={key} className="mb-3">
                        <label className="block text-sm font-medium text-gray-700">
                          {key === "contratoSocial"
                            ? "Contrato Social"
                            : key === "frenteDocumento"
                            ? "Frente do documento de um dos sócios"
                            : key === "versoDocumento"
                            ? "Verso do documento de um dos sócios"
                            : "Selfie segurando seu documento"}
                        </label>

                        <div className="flex items-center justify-center w-full">
                          {!files[key] && !uploadSuccess[key] ? (
                            <>
                              <label
                                htmlFor={key}
                                className="flex flex-col items-center justify-center w-full h-24 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50"
                              >
                                {isLoading[key] && (
                                  <p className="text-center text-sm text-gray-500 mt-3">
                                    Enviando...
                                  </p>
                                )}

                                {!isLoading[key] &&
                                  !uploadProgress[key] > 0 && (
                                    <div className="flex flex-col items-center justify-center pt-4 pb-4">
                                      <svg className="w-6 h-6 mb-2 text-gray-500">
                                        <path
                                          stroke="currentColor"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                        />
                                      </svg>
                                      <p className="mb-1 text-xs text-gray-500">
                                        <span className="font-semibold">
                                          Clique para enviar
                                        </span>
                                      </p>
                                      <p className="text-xs text-gray-500">
                                        PDF ou JPG
                                      </p>
                                    </div>
                                  )}

                                {uploadProgress[key] > 0 &&
                                  uploadProgress[key] < 100 && (
                                    <div className="w-full mt-2">
                                      <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div
                                          className="bg-[#baa78e] h-2.5 rounded-full"
                                          style={{
                                            width: `${uploadProgress[key]}%`
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}

                                <input
                                  id={key}
                                  type="file"
                                  accept=".pdf, .jpg, .jpeg, .png"
                                  className="hidden"
                                  onChange={(e) => handleFileChange(e, key)}
                                  disabled={
                                    isLoading[key] || uploadProgress[key] > 0
                                  }
                                />
                              </label>
                            </>
                          ) : (
                            <div className="w-full text-center">
                              <p className="text-xs text-gray-600 mt-1">
                                {files[key]?.name}
                              </p>
                              {uploadSuccess[key] && (
                                <div className="text-white bg-green-400 py-2 px-4 rounded-md mt-2 inline-flex items-center">
                                  <svg
                                    className="w-5 h-5 mr-2"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M5 13l4 4L19 7"
                                    ></path>
                                  </svg>
                                  <span>Enviado com sucesso!</span>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {step < 4 && (
                  <>
                    {/* Botão de próximo */}
                    <button
                      onClick={handleNext}
                      className="w-full bg-[#767676] mt-4 py-2 rounded-2xl text-white mb-2 flex items-center justify-center"
                    >
                      Próximo
                    </button>
                  </>
                )}

                {step === 4 && (
                  <>
                    {/* Botão de próximo */}
                    <button
                      onClick={handleNext}
                      className="w-full bg-[#767676] mt-4 py-2 rounded-2xl text-white mb-2 flex items-center justify-center"
                    >
                      Finalizar
                    </button>
                  </>
                )}

                {step === 5 && aceito && (
                  <>
                    <button
                      onClick={handleConfirmarTermos}
                      className="w-full bg-[#767676] mt-4 py-2 rounded-2xl text-white mb-2 flex items-center justify-center"
                    >
                      Confirmar
                    </button>
                  </>
                )}

                {step === 6 && allUploaded && (
                  <>
                    <button
                      onClick={handleEnviarform}
                      className="w-full bg-[#767676] mt-4 py-2 rounded-2xl text-white mb-2 flex items-center justify-center"
                    >
                      Finalizar envio
                    </button>
                  </>
                )}

                <button
                  onClick={() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = "/";
                  }}
                  className="w-full bg-[#f09191] mt-4 py-2 rounded-2xl text-white mb-2 flex items-center justify-center"
                >
                  Desconectar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreCadastroComponente;
